const integer = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
const oneDecimal = new Intl.NumberFormat('en-US', { maximumFractionDigits: 1 });

export function formatDistance(km: number | null): string {
  if (km === null) return 'No guess';
  if (km < 1) return `${integer.format(km * 1000)} m`;
  if (km < 10) return `${oneDecimal.format(km)} km`;
  return `${integer.format(km)} km`;
}

/** "1 round", "5 rounds". */
export function roundCount(count: number): string {
  return `${count} round${count === 1 ? '' : 's'}`;
}

export function formatPoints(points: number): string {
  return integer.format(points);
}

export function formatClock(totalSeconds: number): string {
  const seconds = Math.max(0, Math.ceil(totalSeconds));
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, '0')}`;
}

/** "1 min per round", or "No time limit". */
export function timePerRound(seconds: number): string {
  return seconds === 0 ? 'No time limit' : `${formatTimeLimit(seconds)} per round`;
}

export function formatTimeLimit(seconds: number): string {
  if (seconds === 0) return 'No limit';
  if (seconds < 60) return `${seconds}s`;
  return seconds % 60 === 0 ? `${seconds / 60} min` : formatClock(seconds);
}

const dateTime = new Intl.DateTimeFormat('en-GB', {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
});

/** e.g. "Sat 2 Nov, 18:00", in the viewer's time zone. */
export function formatDateTime(epochMs: number): string {
  return dateTime.format(epochMs);
}

const day = new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });

/** A UTC date (YYYY-MM-DD) as "Saturday 1 November". */
export function formatDay(isoDay: string): string {
  return day.format(Date.parse(`${isoDay}T00:00:00Z`));
}

/** e.g. "2 days left", "5 h left", "12 min left". */
export function formatTimeLeft(ms: number): string {
  const minutes = Math.max(1, Math.round(ms / 60_000));
  if (minutes < 60) return `${minutes} min left`;
  const hours = Math.round(minutes / 60);
  if (hours < 48) return `${hours} h left`;
  return `${Math.round(hours / 24)} days left`;
}

const ORDINAL_SUFFIX: Record<number, string> = { 1: 'st', 2: 'nd', 3: 'rd' };

export function ordinal(n: number): string {
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${n}th`;
  return `${n}${ORDINAL_SUFFIX[n % 10] ?? 'th'}`;
}
